import { OnInit } from '@angular/core';
import { SessionService } from '../core/session/session.service';
import { PageGuideService } from './page-guide.service';
var PageGuideComponent = /** @class */ (function () {
    function PageGuideComponent(sessionService, pageGuideService) {
        this.sessionService = sessionService;
        this.pageGuideService = pageGuideService;
    }
    PageGuideComponent.prototype.ngOnInit = function () {
        this.pageGuideService.shutdownPageGuide();
        if (this.sessionService.isUserLogged()) {
            this.pageGuideService.startPageGuide();
        }
    };
    return PageGuideComponent;
}());
export { PageGuideComponent };
